import {
    EntityListWithPagination,
    EntityWithIdAndDescription,
    PaginacionRequest,
    schemaEntityListWithPagination
} from "../../../types";
import {
    SupplierOrderFilterType,
    SupplierOrderHistory,
    SupplierOrderInsertDTO,
    SupplierOrderUpdateDTO,
    SupplierOrderViewDTO,
    schemaSupplierOrderView
} from "../types/dto";
import { HttpAxiosRequest } from "../../../http/httpAxiosBase";

export const getEndpoint = (url = ''): string => `proveedor-pedido/${url}`

export const HttpSupplierOrders = {
    get: (pagination: PaginacionRequest, filter: SupplierOrderFilterType): Promise<EntityListWithPagination<SupplierOrderViewDTO>> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(``), {
            ...pagination,
            ...filter,
        })
            .then(response => {
                const parsed = schemaEntityListWithPagination(schemaSupplierOrderView).safeParse(response)

                if (!parsed.success) {
                    console.error('Validation error:', parsed.error.issues)

                    return Promise.reject(new Error('Validation error.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Network error:', error)

                return Promise.reject('Network error.')
            })
    },

    put: (id: number, data: SupplierOrderUpdateDTO): Promise<any> => {
        return HttpAxiosRequest.put(getEndpoint(`${id}`), data)
    },

    post: (data: SupplierOrderInsertDTO): Promise<any> => {
        return HttpAxiosRequest.post(getEndpoint(``), data)
    },

    getStates: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`estados`))
    },

    getProviders: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`proveedores`))
    },

    getCommunicationChannels: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`canal-comunicacion`))
    },

    getHistory: (id: number): Promise<SupplierOrderHistory[]> => {
        return HttpAxiosRequest.get(getEndpoint(`${id}/historial`))
    },

    getUsers: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`responsables`)
        )
    }

} as const
